import { render } from "./NarrativeGenerationStages.vue?vue&type=template&id=4b969904&scoped=true"
import script from "./NarrativeGenerationStages.vue?vue&type=script&lang=js"
export * from "./NarrativeGenerationStages.vue?vue&type=script&lang=js"

import "./NarrativeGenerationStages.vue?vue&type=style&index=0&id=4b969904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b969904"]])

export default __exports__